(function () {
  function init() {
    if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') {
      setTimeout(init, 100);
      return;
    }

    gsap.registerPlugin(ScrollTrigger);

    const section   = document.getElementById('anzza-about-process');
    const track     = document.getElementById('anzza-process-track');
    const stepCards = Array.from(document.querySelectorAll('.anzza-process-card'));

    if (!section || !track) return;
    if (window.innerWidth < 768) return;

    const totalStepCards = stepCards.length;
    const vh             = window.innerHeight;
    const totalLength    = vh * (totalStepCards - 1) * 0.6;

    stepCards.forEach(function (card, i) {
      if (i === 0) {
        gsap.set(card, { x: '0%', filter: 'blur(0px)', zIndex: 0 });
      } else {
        gsap.set(card, { x: '100%', filter: 'blur(0px)', zIndex: i });
      }
    });

    ScrollTrigger.getAll().forEach(function (st) {
      if (st.trigger === section) st.kill();
    });

    ScrollTrigger.create({
      trigger: section,
      start: 'top top',
      end: function () { return '+=' + totalLength; },
      pin: true,
      scrub: 1,
      anticipatePin: 1,
      invalidateOnRefresh: true,
      onUpdate: function (self) {
        const progress         = self.progress;
        const adjustedProgress = progress * (totalStepCards - 1) + 1;

        gsap.set(track, { x: 0 });

        stepCards.forEach(function (card, i) {
          if (i === 0) {
            const card2P     = Math.min(1, Math.max(0, adjustedProgress - 1));
            const blurAmount = Math.min(card2P * 6, 12);
            gsap.set(card, { x: '0%', filter: 'blur(' + blurAmount + 'px)', zIndex: 0 });
            return;
          }

          const cardStart = i;
          const cardEnd   = i + 1;
          const p         = Math.min(1, Math.max(0, (adjustedProgress - cardStart) / (cardEnd - cardStart)));
          const isActive  = (adjustedProgress >= cardStart && adjustedProgress < cardEnd) ||
                            (i === totalStepCards - 1 && adjustedProgress >= totalStepCards);
          const isPast    = adjustedProgress >= cardEnd;
          const isFuture  = adjustedProgress < cardStart;

          if (isFuture) {
            gsap.set(card, { x: '100%', filter: 'blur(0px)', zIndex: i });
          } else if (isActive) {
            gsap.set(card, { x: (100 - p * 100) + '%', filter: 'blur(0px)', zIndex: totalStepCards + 10 });
          } else if (isPast) {
            let blurAmount = 0;
            for (let j = i + 1; j < totalStepCards; j++) {
              const jP     = Math.min(1, Math.max(0, adjustedProgress - j));
              const behind = j - i;
              blurAmount   = Math.max(blurAmount, jP * (behind * 6));
            }
            gsap.set(card, { x: '0%', filter: 'blur(' + Math.min(blurAmount, 12) + 'px)', zIndex: i });
          }
        });
      }
    });

    window.addEventListener('resize', function () {
      ScrollTrigger.refresh();
    });

    document.addEventListener('shopify:section:load', function (e) {
      if (e.target.querySelector('#anzza-about-process')) init();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
